if (window.templateSuffix == 'wholesale') {
  console.log('B2B Product');
} else {
document.addEventListener("DOMContentLoaded", function () {
  const quantityInput = document.querySelector(".quantity__input");
  const minusBtn = document.querySelector('button[name="minus"]');
  const plusBtn = document.querySelector('button[name="plus"]');
  const tabButtons = document.querySelectorAll(".xstab-button");

  if (!quantityInput) return;

  let lastManualQty = parseInt(quantityInput.value) || 1;

  const getActiveTabBoxes = () => {
    const activeTab = document.querySelector(".xscontent.active");
    return activeTab.querySelectorAll(".xs-variant-box");
  };

  const getAvailableQuantities = () => {
    const boxes = getActiveTabBoxes();
    let quantities = [];
    boxes.forEach((box) => {
      const title = box.querySelector(".xs-title-circle")?.innerText || "";
      const match = title.match(/^(\d+)/);
      if (match) {
        quantities.push(parseInt(match[1]));
      }
    });
    quantities.sort((a, b) => a - b);
    return quantities;
  };

  const getClosestLowerOrEqual = (quantities, qty) => {
    let closest = quantities[0];
    for (let i = 0; i < quantities.length; i++) {
      if (quantities[i] <= qty) {
        closest = quantities[i];
      }
    }
    return closest;
  };

  const setActiveBoxByQty = (qty) => {
    const boxes = getActiveTabBoxes();
    const quantities = getAvailableQuantities();
    const activeQty = getClosestLowerOrEqual(quantities, qty);

    boxes.forEach((box) => {
      const titleText = box.querySelector(".xs-title-circle")?.innerText || "";
      const match = titleText.match(/^(\d+)/);
      if (match && parseInt(match[1]) === activeQty) {
        box.classList.add("active");
      } else {
        box.classList.remove("active");
      }
    });
  };

  const syncActiveBox = (forceUpdate = false) => {
    const quantities = getAvailableQuantities();
    let qty = parseInt(quantityInput.value);
    if (isNaN(qty) || qty <= 0) qty = quantities[0];

    // ✅ Only auto-increase quantity if it's lower than new tab's minimum
    const minQty = quantities[0];
    if (forceUpdate && qty < minQty) {
      qty = minQty;
      quantityInput.value = qty;
    }

    setActiveBoxByQty(qty);
  };

  // ✅ Plus/minus click handling
  [minusBtn, plusBtn].forEach((btn) => {
    if (btn) {
      btn.addEventListener("click", () => {
        setTimeout(() => {
          lastManualQty = parseInt(quantityInput.value) || 1;
          syncActiveBox();
        }, 0);
      });
    }
  });

  // ✅ Manual quantity input typing
  quantityInput.addEventListener("input", () => {
    lastManualQty = parseInt(quantityInput.value) || 1;
    syncActiveBox();
  });

  // ✅ Handle variant box click
  const attachVariantBoxClickHandlers = () => {
    const boxes = getActiveTabBoxes();
    boxes.forEach((box) => {
      box.addEventListener("click", () => {
        const title = box.querySelector(".xs-title-circle")?.innerText || "";
        const match = title.match(/^(\d+)/);
        if (match) {
          const quantity = parseInt(match[1]);
          quantityInput.value = quantity;
          lastManualQty = quantity;
          syncActiveBox();
        }
      });
    });
  };

  // ✅ Handle tab switching
  tabButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      document.querySelectorAll(".xstab-button").forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");

      const id = btn.getAttribute("data-id");
      document.querySelectorAll(".xscontent").forEach((tab) => {
        tab.classList.remove("active");
        if (tab.id === id) tab.classList.add("active");
      });

      attachVariantBoxClickHandlers();
      syncActiveBox(true);  // <-- force check on tab switch
    });
  });

  // ✅ Initial setup
  attachVariantBoxClickHandlers();
  syncActiveBox();
});
}


document.addEventListener("DOMContentLoaded", function () {
  const qtyComponents = document.querySelectorAll("loess-quantity-input");

  qtyComponents.forEach((component) => {
    const minusBtn = component.querySelector('button[name="minus"]');
    const plusBtn = component.querySelector('button[name="plus"]');
    const input = component.querySelector('input.quantity__input');

    const updateButtons = () => {
      const value = parseInt(input.value);

      if (value <= 1) {
        minusBtn.classList.add("disabled");
      } else {
        minusBtn.classList.remove("disabled");
      }

      // if (value >= 3) {
      //   plusBtn.classList.add("disabled");
      // } else {
      //   plusBtn.classList.remove("disabled");
      // }
    };

    // Update on any change to input
    input.addEventListener("input", updateButtons);
    input.addEventListener("change", updateButtons);

    // Update after native button clicks (using mutation observer or delay)
    minusBtn.addEventListener("click", () => {
      setTimeout(updateButtons, 0);
    });

    plusBtn.addEventListener("click", () => {
      setTimeout(updateButtons, 0);
    });

    // Initial state
    updateButtons();
  });
});


$(".xstab-button").click(function() {
  var purchase_type = $(this).data("id");
  if (purchase_type == "home") {
    $(".sub_payment_method").hide();
    $(".onetime_payment_method").show();
    $(".trial-product").show();
    $(".product-template-tab-subscription__dropdown-container").appendTo(".product-template-tab-subscription__wrapper");
    $(".product-template-tab-subscription__dropdown-wrapper").appendTo(".subscription-setup");
  } else if (purchase_type == "about") {
    $(".sub_payment_method").show();
    $(".onetime_payment_method").hide();
    $(".trial-product").hide();
    $(".product-template-tab-subscription__dropdown-container").appendTo(".quantity-container");
    $(".product-template-tab-subscription__dropdown-wrapper").appendTo(".quantity-container");
  }
})
var initiallySelectedPlanId = $('input[name="selling_plan"]:checked').val();
$('.variant-subscription-price[data-selling-plan-id="' + initiallySelectedPlanId + '"]').show();
var frequency_label = $("input.sub_frequency:checked").siblings("label").text();
$(".product-template-tab-subscription__dropdown-label").text(frequency_label);

$('.product-template-tab-subscription__dropdown-container').click(function() {
    var div = $('.product-template-tab-subscription__dropdown-list');
    var arrow_icon = $(".product-template-tab-subscription__dropdown-icon");
    var container = $(".product-template-tab-subscription__dropdown-wrapper")
    div.toggleClass('visible-div hidden-div');
    container.toggleClass('active');
    arrow_icon.toggleClass('active');
});

$("input.sub_frequency").on("change", function() {
  var selling_plan = $(this).val();
  var label = $(this).siblings("label").text();
  $(".subscription-frequency-selector").removeClass("active");
  $(this).parents(".subscription-frequency-selector").addClass("active");
  $('.variant-subscription-price').hide();
  $('.variant-subscription-price[data-selling-plan-id="' + selling_plan + '"]').show();
  $(".product-template-tab-subscription__dropdown-label").text(label);
  $(this).parents(".selling-plan-group").toggleClass('visible-div hidden-div');
  var container = $(".product-template-tab-subscription__dropdown-wrapper");
  container.toggleClass('active');
})
$(".subscription-frequency-radio").click(function() {
  $(this).siblings("input.sub_frequency").click();
})
$(".product-template-tab-subscription__info-link").click(function() {
  $(".popup-subscription-info").css({ "opacity": "1", "visibility": "visible" });
  $("body").css("overflow", "hidden");
})

$(".popup__button-close").click(function(){
  $(".popup-subscription-info").css({ "opacity": "0", "visibility": "hidden" });
  $("body").css("overflow", "auto");
})

$(".popup-subscription-info").on('blur',function(){
    $(this).css({ "opacity": "0", "visibility": "hidden" });
});

// $(".main-form__submit").click(function(e) {
//   if($("input#trial-p").is(":checked")) {
//     e.preventDefault();
//     let variant_id = $("input#trial-p:checked").data("variant_id");
//     var data = {
//     "id": variant_id,
//     "quantity": 1
//     }
//     data["sections"] = ["cart-drawer-items", "cart-total-price", "header-cart-icon", "free-shipping-text"];
//     data["selector"] = ["cart-items", "shopify-section", "shopify-section", "shopify-section"];
//     data["sections_url"] = window.location.pathname;
    
//     $.ajax({
//     url: '/cart/add.js',
//     type: 'post',
//     dataType: 'json',
//     data: data,
//     success: function(response) {
//       console.log('Product added', response);
//       $(".product-form__submit").find("span").removeClass("hidden");
//       $(".product-form__submit").find(".spinner").addClass("hide");
//       var cartDrawer = document.querySelector("loess-cart-notification") || document.querySelector("loess-cart-drawer-items");
//       if (cartDrawer) {
//         cartDrawer.renderCartItems(response);
//         setTimeout(() => {
//           document.querySelector(`[aria-controls="${cartDrawer.closest("loess-drawer").id}"`).click();
//         }, 100);
//       } else {
//         window.location = window.LoessTheme.routes.cart_url;
//       }
//     },
//     error: function(xhr, status, error) {
//       console.error('Failed to add products', xhr.responseJSON);
//     }
//   });
//   }
//   else {
    
//   $(this).find("span").addClass("hidden");
//   $(this).find(".spinner").removeClass("hide");
//   e.preventDefault();
//   let variant_id;
//   let qty;
//   var data = {
//     "id": variant_id,
//     "quantity": qty
//   }
//   var selling_option = $("button.xstab-button.active");
//   if(selling_option.hasClass("onetime-selection")) {
//     // variant_id = $(".variantsbox.onetime .xs-variant-box.active").data("variant-id");
//     variant_id = $(".variantsbox.onetime .xs-variant-box:first").data("variant-id");
//   } else {
//     // variant_id = $(".variantsbox.subscription .xs-variant-box.active").data("variant-id");
//     variant_id = $(".variantsbox.subscription .xs-variant-box:first").data("variant-id");
//     var selected_selling_plan = $('.subscription-frequency-selector input[name="selling_plan"]:checked').val();
//     data["selling_plan"] = selected_selling_plan;
//   }
//   qty = $("input[name=quantity]").val();
//   data["id"] = variant_id;
//   data["quantity"] = qty;
//   data["sections"] = ["cart-drawer-items", "cart-total-price", "header-cart-icon", "free-shipping-text"];
//   data["selector"] = ["cart-items", "shopify-section", "shopify-section", "shopify-section"];
//   data["sections_url"] = window.location.pathname;
  
//   $.ajax({
//     url: '/cart/add.js',
//     type: 'post',
//     dataType: 'json',
//     data: data,
//     success: function(response) {
//       console.log('Product added', response);
//       $(".product-form__submit").find("span").removeClass("hidden");
//       $(".product-form__submit").find(".spinner").addClass("hide");
//       var cartDrawer = document.querySelector("loess-cart-notification") || document.querySelector("loess-cart-drawer-items");
//       if (cartDrawer) {
//         cartDrawer.renderCartItems(response);
//         setTimeout(() => {
//           document.querySelector(`[aria-controls="${cartDrawer.closest("loess-drawer").id}"`).click();
//         }, 100);
//       } else {
//         window.location = window.LoessTheme.routes.cart_url;
//       }
//     },
//     error: function(xhr, status, error) {
//       console.error('Failed to add products', xhr.responseJSON);
//     }
//   });
//   };
// })

$("input#trial-p").click(function(e) {
    let variant_id = $("input#trial-p:checked").data("variant_id");
    var data = {
    "id": variant_id,
    "quantity": 1
    }
    data["sections"] = ["cart-drawer-items", "cart-total-price", "header-cart-icon", "free-shipping-text"];
    data["selector"] = ["cart-items", "shopify-section", "shopify-section", "shopify-section"];
    data["sections_url"] = window.location.pathname;
    
    $.ajax({
    url: '/cart/add.js',
    type: 'post',
    dataType: 'json',
    data: data,
    success: function(response) {
      console.log('Product added', response);
      $(".product-form__submit").find("span").removeClass("hidden");
      $(".product-form__submit").find(".spinner").addClass("hide");
      var cartDrawer = document.querySelector("loess-cart-notification") || document.querySelector("loess-cart-drawer-items");
      if (cartDrawer) {
        cartDrawer.renderCartItems(response);
        setTimeout(() => {
          document.querySelector(`[aria-controls="${cartDrawer.closest("loess-drawer").id}"`).click();
        }, 100);
      } else {
        window.location = window.LoessTheme.routes.cart_url;
      }
    },
    error: function(xhr, status, error) {
      console.error('Failed to add products', xhr.responseJSON);
    }
  });
})

$(".main-form__submit").on("click", function (e) {
  e.preventDefault();

  const $btn = $(this);
  const isTrialChecked = $("input#trial-p").is(":checked");

  let variant_id;
  let qty = 1;
  const data = {
    sections: ["cart-drawer-items", "cart-total-price", "header-cart-icon", "free-shipping-text"],
    selector: ["cart-items", "shopify-section", "shopify-section", "shopify-section"],
    sections_url: window.location.pathname
  };

  // if (isTrialChecked) {
  //   variant_id = $("input#trial-p:checked").data("variant_id");
  //   data.id = variant_id;
  //   data.quantity = qty;
  // } else {
    $btn.find("span").addClass("hidden");
    $btn.find(".spinner").removeClass("hide");

    const sellingOption = $("button.xstab-button.active");
    const isOnetime = sellingOption.hasClass("onetime-selection");

    const wholesale_selector = isOnetime
      ? ".variantsbox.onetime .xs-variant-box.active"
      : ".variantsbox.subscription .xs-variant-box.active";

    const selector = isOnetime
      ? ".variantsbox.onetime .xs-variant-box:first"
      : ".variantsbox.subscription .xs-variant-box:first";

    if (window.templateSuffix == 'wholesale') {
      variant_id = $(wholesale_selector).data("variant-id");
    } else {
      variant_id = $(selector).data("variant-id");
    }
    qty = $("input[name='quantity']").val();

    data.id = variant_id;
    data.quantity = qty;

    if (!isOnetime) {
      const selectedPlan = $('.subscription-frequency-selector input[name="selling_plan"]:checked').val();
      if (selectedPlan) {
        data.selling_plan = selectedPlan;
      }
    }
  // }

  $.ajax({
    url: "/cart/add.js",
    type: "POST",
    dataType: "json",
    data,
    success: function (response) {
      console.log("✅ Product added:", response);
      $(".product-form__submit").find("span").removeClass("hidden");
      $(".product-form__submit").find(".spinner").addClass("hide");

      const cartDrawer =
        document.querySelector("loess-cart-notification") ||
        document.querySelector("loess-cart-drawer-items");

      if (cartDrawer) {
        cartDrawer.renderCartItems(response);
        setTimeout(() => {
          document
            .querySelector(`[aria-controls="${cartDrawer.closest("loess-drawer").id}"]`)
            .click();

          // ✅ after render + open → let DOM paint, then apply prices
          queueMicrotask(() => {
            requestAnimationFrame(() => {
              if (window.applyWholesalePricingToDrawer) {
                window.applyWholesalePricingToDrawer();
              } else {
                console.log("No wholesale pricing fetched");
              }
            });
          });
        }, 100);
      } else {
        window.location = window.LoessTheme.routes.cart_url;
      }
    },
    error: function (xhr) {
      console.error("❌ Failed to add product:", xhr.responseJSON);
    }
  });
});


$(".sticky-addtocart").click(function(e) {
  e.preventDefault();
  $(".main-form__submit").click();
  $(this).find("span").addClass("hidden");
  $(this).find(".spinner").removeClass("hide");
})
